import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IOrganizationGeneralInformation {
    name: string;
    street?: string;
    streetNumber?: string;
    zip?: string;
    city?: string;
    country?: INameId;
    additionToAddress?: string;
}
